module.exports = __webpack_public_path__ + "media/rating/somewhat-c49af478.svg";